import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { Box } from '@mui/material'
import { INTERAX_COLORS } from '../../constants/colors'
import { TrainingSprintSection } from '../../types/TrainingSprintTypes'
import TrainingSprintCard from './TrainingSprintCard'

interface TrainingSprintAccordionProps {
  section: TrainingSprintSection
  onToggle: (sectionId: string) => void
  onContinue?: (sprint: any) => void
  onViewDetails?: (sprint: any) => void
}

export default function TrainingSprintAccordion({
  section,
  onToggle,
  onContinue,
  onViewDetails
}: TrainingSprintAccordionProps) {
  const handleToggle = () => {
    onToggle(section.id)
  }

  return (
    <Box
      sx={{
        backgroundColor: INTERAX_COLORS.heritageBlue40,
        borderRadius: '8px',
        overflow: 'hidden'
      }}
    >
      {/* Accordion Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 20px',
          cursor: 'pointer',
          backgroundColor: INTERAX_COLORS.heritageBlue40,
          borderBottom: section.isExpanded ? `1px solid ${INTERAX_COLORS.thunderGrey}` : 'none'
        }}
        onClick={handleToggle}
      >
        <Box className="text-headline-5" sx={{ color: INTERAX_COLORS.white }}>
          {section.title} ({section.count})
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Box className="text-body-3" sx={{ color: INTERAX_COLORS.thunderGrey }}>
            {section.count}
          </Box>
          {section.isExpanded ? (
            <ChevronDownIcon className="w-5 h-5" style={{ color: INTERAX_COLORS.white }} />
          ) : (
            <ChevronRightIcon className="w-5 h-5" style={{ color: INTERAX_COLORS.white }} />
          )}
        </Box>
      </Box>

      {/* Accordion Content */}
      {section.isExpanded && (
        <Box sx={{ padding: '20px' }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '16px' }}>
            {section.sprints.map((sprint) => (
              <TrainingSprintCard
                key={sprint.id}
                sprint={sprint}
                onContinue={onContinue}
                onViewDetails={onViewDetails}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
}
